import React from 'react';

import { link, LinkButton, phone } from '../utils';

export default (
    <div>
        <p> Skadebehandling for inntektsforsikring behandles av vår samarbeidspartner AXA.</p>

        <p>
            Forsikringen gir ingen dekning de første 30 dagene. Vi ber derfor om at du venter med å registrere ditt krav
            og laste opp dine dokumenter til etter at du har mottatt dagpenger fra NAV i over 60 dager.
        </p>

        <p>Slik melder du krav hos AXA</p>

        <ol>
            <li>Opprett en brukerkonto og registrer ditt forsikringskrav.</li>
            <ul>
                <li> Ved utfylling av &quot;avtalenummer&quot; benytter du avtalenummeret på din forsikringspolise.</li>
                <li> Trykk &quot;send inn&quot; for å registrere krav og laste opp dokumenter. </li>
            </ul>

            <li>Last opp følgende dokumenter:</li>

            <ul>
                <li>
                    Arbeidskontrakt(er) som bekrefter at du har vært i arbeid i sammenhengende 12 måneder rett forut for
                    arbeidsledighets- eller permitteringsperioden. Det er viktig at stillingsbrøk fremkommer.
                </li>
                <li>Oppsigelses- eller permitteringsvarsel hvor årsak og varslingsdato tydelig fremkommer. </li>
                <li> Vedtak om innvilgede dagpenger fra NAV. </li>
                <li>
                    Utbetalingsoversikt fra NAV som bekrefter at du har mottatt fullt med dagpenger i en sammenhengende
                    periode på minimum 60 dager fra vedtaksdato.
                </li>
            </ul>
        </ol>

        <p className="inline">Kontaktinformasjon AXA </p>
        <p className="inline">Telefon: {phone('800 37 500')}</p>
        <p className="inline">E-post: {link('clp.no.kundeservice@partners.axa')}</p>

        <p>
            AXA behandler normalt saker innen 10 arbeidsdager, men grunnet høyere volum i meldte saker vil det kunne ta
            noe lengre tid. Du vil motta tilbakemelding når din sak er ferdig behandlet.
        </p>

        <LinkButton href="https://www.clpnet.com/customer/homeno" external>
            Meld skade hos AXA
        </LinkButton>
    </div>
);
